module.exports = __webpack_public_path__ + "img/校外基础教育培训机构@2x.ef0e6daa.png";